import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import {swiperObserver} from "../../utils/swiper.utils.js";

let relatedJobsSwiperWr = document.querySelectorAll('.related-jobs-swiper-wr');
relatedJobsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');

    if (!swiperEl) {
      return;
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true,
      observeParents: true,
      spaceBetween: 12,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        641: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
        961: {
          spaceBetween: 24,
          slidesPerView: 1.5,
        },
        1100: {
          spaceBetween: 40,
          slidesPerView: 2,
        },
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });

    swiperObserver(swiper);
  }
});
